"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportradarEnforcerFactory = void 0;
const SportradarEnforcer_1 = require("../Casbin/SportradarEnforcer");
const SportradarCasbinModel_1 = require("../Casbin/model/SportradarCasbinModel");
const srnMatcher_1 = __importDefault(require("../Casbin/model/srnMatcher"));
const featureMatcher_1 = __importDefault(require("../Casbin/model/featureMatcher"));
class SportradarEnforcerFactory {
    async createFromProxyEvent(event) {
        const enforcer = await SportradarEnforcerFactory.createEnforcer();
        const userId = this.getUserIdFromProxyEvent(event);
        const roles = this.getRolesFromProxyEvent(event);
        const policies = this.getPoliciesFromProxyEvent(event);
        await Promise.all(policies.map((policy) => enforcer.addPolicy(...policy)));
        await enforcer.addRolesForUser(roles, userId);
        return enforcer;
    }
    async createFromMarketingCloudUser(user) {
        const enforcer = await SportradarEnforcerFactory.createEnforcer();
        await Promise.all(user.getPolicies().map((policy) => enforcer.addPolicy(...policy)));
        await enforcer.addRolesForUser(user.getRoles(), user.getPrincipalId());
        return enforcer;
    }
    static async createEnforcer() {
        const enforcer = new SportradarEnforcer_1.SportradarEnforcer();
        await enforcer.initWithModelAndAdapter((0, SportradarCasbinModel_1.getSportradarCasbinModel)());
        await enforcer.addFunction('srn_matcher', srnMatcher_1.default);
        await enforcer.addFunction('feature_matcher', featureMatcher_1.default);
        return enforcer;
    }
    // noinspection JSMethodCanBeStatic
    getUserIdFromProxyEvent(event) {
        return event.requestContext.authorizer.principalId;
    }
    // noinspection JSMethodCanBeStatic
    getRolesFromProxyEvent(event) {
        return JSON.parse(event.requestContext.authorizer.roles);
    }
    // noinspection JSMethodCanBeStatic
    getPoliciesFromProxyEvent(event) {
        return JSON.parse(event.requestContext.authorizer.policies);
    }
}
exports.SportradarEnforcerFactory = SportradarEnforcerFactory;
//# sourceMappingURL=SportradarEnforcerFactory.js.map